export default __webpack_public_path__ + "static/media/N.b90d7a38.wav";